import { useMemo } from 'react';
import axios from "axios";
import useAuth from "./useAuth";

export default function useAPI() {
    const auth = useAuth();
    const fetcher = useMemo(() => {
        const axiosInstance = axios.create({
            baseUrl: "/api",
            timeout: 30000,
            headers: {},
        });

        axiosInstance.interceptors.request.use(
            async (config) => {

                const token = await auth.magic.user.getIdToken();

                return {
                    ...config,
                    headers: {
                        ...config.headers,
                        authorization: `Bearer ${token}`,
                    },
                }
            },
            (error) => Promise.reject(error),
        );

        axiosInstance.interceptors.response.use(
            ({ data }) => data,
            (error) => Promise.reject(error),
        );

        return axiosInstance
    }, [auth]);
    return fetcher;
}